import { plural, t } from "@lingui/macro";
import EducationVideoAthleteProfile from "@/assets/EducationVideoAthleteProfile.jpg";

export type EducationVideoId = "athlete_profile";

export interface EducationVideo {
  title: string;
  youtubeId: string;
  thumbnail: string;
  lengthSeconds: number;
}

/** The Wahoo Metrics videos shown in the app, played in-app from YouTube. */
export const getEducationVideos = (): Record<EducationVideoId, EducationVideo> => ({
  athlete_profile: {
    title: t`Wahoo Metrics: Athlete Profile`,
    youtubeId: "iByAKBa08uk",
    thumbnail: EducationVideoAthleteProfile,
    lengthSeconds: 118,
  },
});

export const isEducationVideoId = (id: string | undefined): id is EducationVideoId =>
  id === "athlete_profile";

/** The length rounded to whole minutes, as the education cards show it ("2 mins"). */
export const formatVideoLength = (lengthSeconds: number) => {
  const minutes = Math.max(1, Math.round(lengthSeconds / 60));
  return plural(minutes, { one: "# min", other: "# mins" });
};

/** Privacy-enhanced embed, so the athlete stays in the app and YouTube sets no cookies. */
export const getEmbedUrl = (youtubeId: string) =>
  `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&playsinline=1&rel=0`;

export const youTubeWatchUrl = (youtubeId: string) =>
  `https://www.youtube.com/watch?v=${youtubeId}`;
